export default {
  'STREAM_QUALITY': 'quality', // low or high quality camera video
  'STREAM_MODE': 'mode', // live or archive camera video
  'SHOW_ALARMED_CAMS': 'alarmedCams', // show alarmed cams on map
}


// WEBPACK FOOTER //
// ./src/consts/sessionStorageKeys.js